import script from "./DocumentDelete.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentDelete.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentDelete.vue?vue&type=style&index=0&id=0a99ae72&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a99ae72"]])

export default __exports__